export const RECEIVE_SYNCHRO = 'RECEIVE_SYNCHRO';
export const REFRESH_PROVIDER = 'REFRESH_PROVIDER';
